import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { BaseStoreService } from '@shared/stores/base-store.service';
import { ResetPasswordModalComponent } from '../reset-password-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordModalStoreService extends BaseStoreService<string> {

  constructor(
    private ngbModal: NgbModal,
  ) {
    super();
  }

  show(token?: string): NgbModalRef {
    this.current = token || null;

    return this.ngbModal.open(ResetPasswordModalComponent);
  }
}
